import React, { useEffect, useState } from "react";
import { useSidebar } from "../../context/SidebarContext";
import DropdownArrow from "../../assets/svgs/LoginSignup/Step1/dropdown_icon.svg";
import {
  DashboardContainer,
  StoreInfoCard,
  StoreInfoContent,
  StoreIcon,
  StoreImage,
  StoreDetails,
  StoreName,
  StoreAddress,
  DropdownIcon,
  DropdownWrapper,
  StoreLocationDropdown,
  DropdownItem,
  OverviewSection,
  OverviewIcon,
  OverviewContent,
  OverviewTitle,
  StatsGrid,
  StatItem,
  StatLabel,
  StatValue,
  StatsCardsGrid,
  StatsCard,
  StatsCardHeader,
  StatsCardIcon,
  StatsCardTitle,
  StatsCardValue,
  StatsCardSubvalue,
  StatsCardSubvalueBold,
  StatsCardIconFeedback,
  HawkerName,
} from "../../styles/dashboard";
import { GET } from "../../services/HTTPServices";
import moment from "moment";
import InfoOutlineIcon from "@mui/icons-material/InfoOutline";

import Cash from "../../assets/svgs/Dashboard/Cash.svg";
import Menu from "../../assets/svgs/Dashboard/Menu.svg";
import Revenue from "../../assets/svgs/Dashboard/Revenue.svg";
import Star from "../../assets/svgs/Dashboard/Star.svg";
import StoreSvg from "../../assets/svgs/Dashboard/StoreIcon.svg";
import StoreLocator from "../../assets/svgs/Dashboard/StoreLocator.svg";
import { setItemWithObject } from "../../utils/cache/LocalStorage";
import { alertMessage } from "../../services/alertService";
import { ALERT_TITLES } from "../../constants";
import StatisticsChart from "./StatisticsChart";
import OnboardingChecklist from "../../components/dashboard/OnboardingChecklist";
import { InfoView, VerificationText } from "../../styles/dashboardLayout";
import {
  LoadingOverlay,
  LoadingSpinner,
  LoadingSpinnerIcon,
} from "../../styles/loading";
import {
  ShopNameContainer,
} from "../../styles/PersonalInfoStep";

type ShopDetails = {
  id: number;
  shopName: string;
  city: string;
  postcode: string;
  unit: string;
  building: string;
  hawker: any;
  floor: string;
  storeCoverPath: any;
};

type Overview = {
  id: number;
  grossRevenue: number;
  feedbackGain: number;
  feedbackAll: number;
  inventory: number;
  customers: number;
};

type TodayOverview = {
  id: number;
  goal: number;
  sales: number;
  orders: number;
  delivered: number;
  pending: number;
};

type Order = {
  id: number;
  orderId?: string;
  category: string;
  createdAt: string;
  ordersCount?: number;
  noOfOrder?: number;
};

type DashboardValues = {
  categories: any[];
  overview: Overview;
  todayOverView: TodayOverview;
  statistic: any;
  orders: Order[];
  shop: ShopDetails[];
  checkList: null;
};

const Dashboard: React.FC = () => {
  const { isSidebarCollapsed } = useSidebar();
  const [selectedStoreIndex, setSelectedStoreIndex] = useState(0);
  const [storeDropdownOpen, setStoreDropdownOpen] = useState(false);
  const [selectedPeriod, setSelectedPeriod] = useState("Monthly");

  const [loading, setLoading] = React.useState(false);

  const [auth, setAuth] = React.useState<any>(null);
  const [openVerified, setOpenVerified] = React.useState<boolean>(false);
  const [isVerified, setIsVerified] = React.useState<boolean>(false);

  const [values, setValues] = React.useState<DashboardValues>({
    categories: [],
    overview: {
      id: 0,
      grossRevenue: 0,
      feedbackGain: 0,
      feedbackAll: 0,
      inventory: 0,
      customers: 0,
    },
    todayOverView: {
      id: 0,
      goal: 0,
      sales: 0,
      orders: 0,
      delivered: 0,
      pending: 0,
    },
    statistic: [],
    orders: [
      {
        id: 1,
        orderId: "#00001",
        category: "Desserts",
        createdAt: "2025-05-23T06:46:30.182Z",
        ordersCount: 2,
      },
    ],
    shop: [],
    checkList: null,
  });

  
  useEffect(() => {
    const authUser = JSON.parse(localStorage.getItem("authUser") || "null");
    if (authUser) {
      setAuth(authUser);
      getShopDetails();
      getDataOverView(authUser.id);
      getDataTodayOverView(authUser.id);
      getDataStatistic(authUser.id);
      getCheckList(authUser.id);
    }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const currentPath = window.location.pathname.split("/")[1];
    if (currentPath === "dashboard-kyb") {
      const authUser = JSON.parse(localStorage.getItem("authUser") || "null");
      if (authUser) {
        getCheckList(authUser.id,true);
        setOpenVerified(true);
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window.location.pathname]);

  const getShopDetails = async () => {
    const authUser = JSON.parse(localStorage.getItem("authUser") || "null");
    if (authUser) {
      const res: any = await GET(
        "serviceprovider/GetServiceProviderAddress?id=" + authUser.id,
        "provider"
      );
      if (res && res.data) {
        setValues((prevValues) => ({ ...prevValues, shop: res.data }));
      }
    }
  };

  const getDataOverView = async (id: any, period = selectedPeriod) => {
    let res: any = await GET(
      "dashboard/GetSPOverview?spId=" + id + "&period=" + period.toLowerCase(),
      "provider"
    );
    if (res && res.data) {
      setValues((prevValues) => ({
        ...prevValues,
        overview: res.data,
      }));
    }
  };

  const getDataTodayOverView = async (id: any) => {
    let res: any = await GET(
      "dashboard/GetSPTodayOverview?spId=" + id,
      "order"
    );
    if (res && res.data) {
      setValues((prevValues) => ({
        ...prevValues,
        todayOverView: res.data,
      }));
    }
  };

  const getCheckList = async (id: any,isKYB = false) => {
    const res: any = await GET(
      "onboardingcheck/GetOnboardingCheckBySpId?spId=" + id,
      "provider"
    );
    if (res && res.data) {
      setLoading(false)

      setItemWithObject("check_list", res.data[0]);
      setValues((prevValues) => ({ ...prevValues, checkList: res.data[0] }));
      if(isKYB){

      alertMessage(
        ALERT_TITLES.SUCCESS,
        "You have done KYB process successfully,"
      );
      }
      if (
        res.data[0].personalInfo === 2 &&
        res.data[0].businessInfo === 2 &&
        res.data[0].kyb === 2 &&
        res.data[0].fileUpload === 2 &&
        res.data[0].agreement === 2
      )
        setIsVerified(true);
      else setIsVerified(false);
    }
  };

  const openVerifiedPopup = () => {
    setOpenVerified(!openVerified);
  };

  const getDataStatistic = async (id: any, period = selectedPeriod) => {
    let res: any = await GET(
      "dashboard/GetSPStatic?spId=" + id + "&period=" + period.toLowerCase(),
      "order"
    );

    if (res && res.data) {
      let temp = res.data;

      const transformedData = temp.map((item: any) => {
        const salesValue = parseFloat(item.sales) || 0;
        const growthValue = parseFloat(item.growth) || 0;

        const maxValue = Math.max(
          ...temp.map((d: any) => parseFloat(d.sales) || 0)
        );
        const scaledMax = maxValue > 0 ? maxValue : 6;

        // Fix the monthName issue with proper null/undefined checks
        let monthName = "";
        if (item.monthName && typeof item.monthName === "string") {
          monthName = item.monthName.toUpperCase();
        } else if (item.day && typeof item.day === "string") {
          monthName = item.day.toUpperCase();
        } else {
          monthName = "N/A"; // fallback value
        }

        return {
          month: monthName,
          value: salesValue,
          height: (salesValue / scaledMax) * 100,
          year: item.year || moment(item.date).format("MMM YYYY").toUpperCase(),
          growth:
            growthValue === 0
              ? "0%"
              : growthValue > 0
              ? `+${growthValue}%`
              : `${growthValue}%`,
        };
      });

      setValues((prevValues) => ({
        ...prevValues,
        statistic: transformedData,
      }));
    }
  };

  const toggleStoreDropdown = () => {
    setStoreDropdownOpen(!storeDropdownOpen);
  };

  const selectStore = (index: number) => {
    setSelectedStoreIndex(index);
    setStoreDropdownOpen(false);
  };



  const selectPeriod = (period: any) => {
    setSelectedPeriod(period);
    getDataOverView(auth.id, period);
    getDataStatistic(auth.id, period);
  };

  const backChecklist = (url: string) => {
    setOpenVerified(false);
    handleKYB(url);
  };

let kybWindow: Window | null = null; // store reference outside the function

const handleKYB = (url: string) => {
    if (!url) return;

    if (kybWindow && !kybWindow.closed) {
        kybWindow.close();
    }
    kybWindow = window.open(url, "_blank");
};


  return (
    <>
      {loading && (
        <LoadingOverlay>
          <LoadingSpinner>
            <LoadingSpinnerIcon />
          </LoadingSpinner>
        </LoadingOverlay>
      )}
        <DashboardContainer $isSidebarCollapsed={isSidebarCollapsed}>
          {/* Store Info Card */}
          <StoreInfoCard>
            <StoreInfoContent>
              <StoreIcon $isSidebarCollapsed={isSidebarCollapsed}>
                <StoreImage
                  src={
                    values?.shop[selectedStoreIndex]?.storeCoverPath[0]
                      ?.imagePath || StoreSvg
                  }
                  alt="Store"
                />
              </StoreIcon>
              <StoreDetails>
                <StoreName>
                  <HawkerName>
                    {values?.shop[selectedStoreIndex]?.hawker.name}{" "}
                  </HawkerName>
                  <VerificationText $isVerified={!!isVerified}>
                    {isVerified ? "Verified" : "Unverified"} &nbsp;
                    <InfoView
                      $isVerified={!!isVerified}
                      onClick={openVerifiedPopup}
                    >
                      <InfoOutlineIcon />
                    </InfoView>
                  </VerificationText>
                </StoreName>
                <ShopNameContainer>
                  <StoreAddress>
                    <img src={StoreLocator} alt="StoreLocator" />
                    {values?.shop[selectedStoreIndex]?.shopName}, Stall #
                    {values?.shop[selectedStoreIndex]?.floor} -
                    {values?.shop[selectedStoreIndex]?.unit}
                  </StoreAddress>
                  {values.shop && values.shop.length > 1 && (
                    <DropdownWrapper>
                      <DropdownIcon onClick={toggleStoreDropdown}>
                        <img src={DropdownArrow} alt="DropdownArrow" />
                      </DropdownIcon>
                      <StoreLocationDropdown $isOpen={storeDropdownOpen}>
                        {values.shop.map((location, index) => (
                          <DropdownItem
                            key={index}
                            onClick={() => selectStore(index)}
                          >
                            {location.hawker?.name}
                          </DropdownItem>
                        ))}
                      </StoreLocationDropdown>
                    </DropdownWrapper>
                  )}
                </ShopNameContainer>
              </StoreDetails>
            </StoreInfoContent>
          </StoreInfoCard>

          {/* Today's Overview Section */}
          <OverviewSection>
            <OverviewIcon>
              <img src={Cash} alt="Cash" />
            </OverviewIcon>

            <OverviewContent>
              <OverviewTitle>TODAY'S OVERVIEW</OverviewTitle>
              <StatsGrid>
                <StatItem>
                  <StatLabel>TOTAL SALES</StatLabel>
                  <StatValue>$ {values.todayOverView?.sales}</StatValue>
                </StatItem>
                <StatItem>
                  <StatLabel>ORDERS</StatLabel>
                  <StatValue>{values.todayOverView?.orders}</StatValue>
                </StatItem>
                <StatItem>
                  <StatLabel>COMPLETED</StatLabel>
                  <StatValue>{values.todayOverView?.delivered}</StatValue>
                </StatItem>
                <StatItem>
                  <StatLabel>PENDING</StatLabel>
                  <StatValue>{values.todayOverView?.pending}</StatValue>
                </StatItem>
              </StatsGrid>
            </OverviewContent>
          </OverviewSection>

          {/* Statistics Chart */}
          <StatisticsChart
            data={values.statistic}
            callback={(res: any) => selectPeriod(res)}
          />

          {/* Stats Cards */}
          <StatsCardsGrid>
            <StatsCard>
              <StatsCardHeader>
                <StatsCardIcon>
                  <img src={Revenue} alt="Revenue" />
                </StatsCardIcon>
                <StatsCardTitle>GROSS REVENUE</StatsCardTitle>
              </StatsCardHeader>
              <StatsCardValue>$ {values.overview?.grossRevenue.toFixed(2)}</StatsCardValue>
            </StatsCard>
            <StatsCard>
              <StatsCardHeader>
                <StatsCardIcon>
                  <img src={Menu} alt="Menu" />
                </StatsCardIcon>
                <StatsCardTitle>FOOD MENU</StatsCardTitle>
              </StatsCardHeader>
              <StatsCardValue>
                {values.overview?.inventory}{" "}
                <StatsCardSubvalue>items</StatsCardSubvalue>
              </StatsCardValue>
            </StatsCard>
            <StatsCard>
              <StatsCardHeader>
                <StatsCardIcon>
                  <img src={Menu} alt="ORDERS" />
                </StatsCardIcon>
                <StatsCardTitle>ORDERS</StatsCardTitle>
              </StatsCardHeader>
              <StatsCardValue>{values.overview?.customers}</StatsCardValue>
            </StatsCard>
            <StatsCard>
              <StatsCardHeader>
                <StatsCardIconFeedback>
                  <img src={Star} className="star-image" alt="Star" />
                </StatsCardIconFeedback>
                <StatsCardTitle>USERS FEEDBACK</StatsCardTitle>
              </StatsCardHeader>
              <StatsCardValue>
                <StatsCardSubvalueBold>
                  {values.overview?.feedbackGain.toFixed(2)}
                </StatsCardSubvalueBold>
                <StatsCardSubvalue>
                  /{values.overview?.feedbackAll.toFixed(2)}
                </StatsCardSubvalue>
              </StatsCardValue>
            </StatsCard>
          </StatsCardsGrid>
        </DashboardContainer>

      {/* Onboarding Checklist Modal - shown for both mobile and desktop */}
      {openVerified && values.checkList && (
        <OnboardingChecklist
          onClose={openVerifiedPopup}
          goKYB={(url: string) => backChecklist(url)}
          data={values.checkList}
        />
      )}

      {/* {kybURL && kybURL !== "" && (
        <FullScreenContainer>
<StyledIframe 
  src={kybURL} 
  title="stripe-kyb" 
  allowFullScreen 
  sandbox="allow-scripts allow-same-origin allow-forms"
/>
        </FullScreenContainer>
      )} */}
    </>
  );
};

export default Dashboard;
